import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import artHuddleDemo from '@/assets/Projects/ArtHuddlePhotos/ArtHuddleDemo.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArtHuddleProject',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'ArtHuddle',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Backend Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "January 2026 - May 2026")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " Launched a multi-user C++ drawing app with custom GUI rendering, text input, audio playback, real-time canvas updates in a team of 3 "),
          _createElementVNode("span", { class: "block" }, " Engineered a thread-safe client-server network with sockets to synchronize drawing, dragging, updating, & deleting elements between connected users "),
          _createElementVNode("span", { class: "block" }, " Architected an SDL3 graphics API utilizing CRTP, threading, factories, custom event system singleton, & metaprogramming for reusable drawing elements & efficient SDL screen drawing "),
          _createElementVNode("span", { class: "block" }, " Presented to PhD students & professor as stakeholders biweekly, iterating on feedback to improve usability & functionality "),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode(" View our "),
            _createElementVNode("a", {
              href: "https://github.com/cgreen2048/ArtHuddle",
              target: "_blank",
              class: "link-in-text"
            }, "GitHub repo"),
            _createTextVNode(" or "),
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=QVpjFrVt47o",
              target: "_blank",
              class: "link-in-text"
            }, "watch a demo"),
            _createTextVNode("! ")
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(artHuddleDemo),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(artHuddleDemo), 'ArtHuddle Demo', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})